import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { isBlumosInsertion, isSolutecInsertion } from "../../../services/auth/selectors";
import { getIsExporting } from "../../../services/insertProcess/selectors";
import { triggerExportProcess } from "../../../services/insertProcess/actions";
import InsertProcessView from "./InsertProcessView";

const InsertProcess = () => {
  const dispatch = useDispatch();
  const isSolutecInsetable = useSelector((state) => isSolutecInsertion(state));
  const isBlumosInsertable = useSelector((state) => isBlumosInsertion(state));
  const isExporting = useSelector((state) => getIsExporting(state));

  const handleExportProcess = (adClientId) => {
    dispatch(triggerExportProcess(adClientId))
      .then((action) => {
        if (triggerExportProcess.fulfilled.match(action)) {
          const resp = action.payload; // axios response
          if (!resp || !resp.data) return;
          const blob = new Blob([resp.data], { type: "text/csv;charset=utf-8" });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          // Try to get filename from header
          const disp = resp.headers && resp.headers["content-disposition"];
          let filename = `conteos_${adClientId}.csv`;
          if (disp) {
            const match = /filename\s*=\s*([^;]+)/i.exec(disp);
            if (match && match[1]) filename = match[1].replace(/\"/g, "").trim();
          }
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
        }
      });
  };

  return (
    <InsertProcessView
      handleExportProcess={handleExportProcess}
      isSolutecInsetable={isSolutecInsetable}
      isBlumosInsertable={isBlumosInsertable}
      isExporting={isExporting}
    />
  );
};

InsertProcess.propTypes = {};

export default InsertProcess;
